/* eslint-disable */
import '@babel/polyfill';
import '@babel/plugin-syntax-dynamic-import';
import 'leaflet';
import './polyfill/arrayFrom';
import './polyfill/arrayFind';
import './polyfill/dataset';

import * as conditioner from 'conditioner-core/conditioner-core.min';

import Rgpd from './modules/rgpd';
import Cookies from './modules/cookies';
import Atinternet from './modules/atinternet';
import * as Utils from './modules/components/utils.js';

function copyPressPaper(el) {
    let range = document.createRange();
    let selection = window.getSelection();

    const fromElement = document.createElement('div');
    fromElement.className = "sr-only"
    fromElement.innerText = el.dataset.url;
    fromElement.id = el.dataset.id;

    document.body.appendChild(fromElement);

    range.selectNode(fromElement);
    selection.removeAllRanges();
    selection.addRange(range);

    try {
        const result = document.execCommand('copy');
        if (result) {
            alert('Adresse copiée dans le presse papier.');
            fromElement.remove();
        }
    }
    catch (err) {
        alert(err);
    }

    selection = window.getSelection();

    if (typeof selection.removeRange === 'function') {
        selection.removeRange(range);
    } else if (typeof selection.removeAllRanges === 'function') {
        selection.removeAllRanges();
    }
}

//
const share_copy = document.querySelectorAll('.fr-share__link--copy');
if (share_copy) {
    share_copy.forEach(link => {
        link.addEventListener('click', () => {
            copyPressPaper(link);
        });
    });
}
const btn_user = document.getElementById('account-btn');
if (btn_user) {
    btn_user.addEventListener('click', () => {
        // btn_user.setAttribute('aria-expanded', true);
        const modale = document.getElementById(btn_nav.getAttribute('aria-controls'));
        const btn_close = modale.querySelector('.fr-link--close');
        btn_close.addEventListener('click', () => {
            // btn_nav.setAttribute('aria-expanded', false);
        }, { once: true });
    })
}

const btn_user_validation = document.getElementById('btn-user-validation');
if (btn_user_validation) {
    btn_user_validation.addEventListener('click', () => {
        btn_user_validation.setAttribute('aria-expanded', true);
        const modale = document.getElementById(btn_nav.getAttribute('aria-controls'));
        const btn_close = modale.querySelector('.fr-link--close');
        btn_close.addEventListener('click', () => {
            btn_nav.setAttribute('aria-expanded', false);
        }, { once: true });
    })
}


const gg = document.querySelector('#modal-signin-valid .fr-link--close');
gg.addEventListener('click', () => {
    setTimeout(() => {
        document.getElementById('account-btn').focus();
    }, 500)
});


// nav mobile connection deconexion
const btn_nav = document.getElementById('btn-nav');
if (btn_nav) {
    btn_nav.addEventListener('click', () => {

        btn_nav.setAttribute('aria-expanded', true);
        const modale = document.getElementById(btn_nav.getAttribute('aria-controls'));
        const btn_close = modale.querySelector('.fr-link--close');

        btn_close.addEventListener('click', () => {
            btn_nav.setAttribute('aria-expanded', false);
        }, { once: true });

        setTimeout(() => {
            const btn_loggout = document.querySelector('.fr-header__menu .btn-logout');
            if (btn_loggout) {
                btn_loggout.addEventListener('click', () => {
                    const ajaxData = new FormData();
                    const request = new XMLHttpRequest();
                    const url = window.ParamsDataPopin.wp_ajax_url;

                    ajaxData.append('action', 'logout');
                    ajaxData.append('nonce', window.ParamsDataPopin.nonce);

                    request.open('POST', url, true);
                    request.send(ajaxData);

                    request.onload = () => {
                        let response = request.response;

                        if (typeof response === 'string') {
                            response = JSON.parse(response);
                        }

                        switch (response.status) {
                            case 200:
                                window.location.replace(response.url);
                                break;
                            default:
                                break;
                        }
                    };


                })
            }

            const btn_login = document.querySelector('#account-btn_copy');
            if (btn_login) {
                btn_login.addEventListener('click', () => {
                    let event = new Event("click");
                    document.getElementById('account-btn').dispatchEvent(event);
                });
            }
        }, 300);
    })
}


const body = document.querySelector('body');
const header = document.querySelector('header[role="banner"]');
const main = document.querySelector('main[role="main"]');
const footer = document.querySelector('footer[role="contentinfo"]');
const aside = document.querySelector('aside[role="complementary"]');

// WP params to window
window.ParamsDataSearch = JSON.parse(document.getElementById('ParamsDataSearch').dataset.json);
window.ParamsDataPopin = JSON.parse(document.getElementById('ParamsDataPopin').dataset.json);
window.ParamsDataGoogle = JSON.parse(document.getElementById('ParamsDataGoogle').dataset.json);
window.ParamsDataEnv = JSON.parse(document.getElementById('ParamsDataEnv').dataset.json);
window.dataLayer = window.dataLayer || [];

// show IE modal if is in page
window.addEventListener("DOMContentLoaded", (event) => {
    const documentHtml = document.querySelector('html');
    const oldNav = document.querySelector('.strate-old-navigator');

    if (oldNav) {
        documentHtml.classList.add('fr-no-scroll');
        header.setAttribute('aria-hidden', true);
        main.setAttribute('aria-hidden', true);
        footer.setAttribute('aria-hidden', true);
        aside.setAttribute('aria-hidden', true);
    }

});

// set css var --vh
function setVh() {
    let vh = window.innerHeight * 0.01;
    let vh_tmp = document.documentElement.style.getPropertyValue('--vh');

    if (vh !== vh_tmp) {
        document.documentElement.style.setProperty('--vh', `${vh}px`);
    }

}

setVh();
window.addEventListener('resize', setVh);

// close account panel on click outside
const accountBtn = document.querySelector('#account-list-btn');
if (accountBtn) {

    const accountPanel = document.querySelector('#account-list-nav');

    document.addEventListener("click", (e) => {

        let target = e.target;

        do {
            if (target !== document) {

                if (target.id == "account-list") {
                    return;
                }
            }

            target = target.parentNode;

        } while (target);

        if (accountBtn.getAttribute('aria-expanded') == true || accountBtn.getAttribute('aria-expanded') == "true") {
            accountBtn.dispatchEvent(new Event('click'));
        }
    });

    document.addEventListener("keyup", (e) => {
        if (e.key == "Escape") {
            if (accountBtn.getAttribute('aria-expanded') == true || accountBtn.getAttribute('aria-expanded') == "true") {
                accountBtn.dispatchEvent(new Event('click'));
            }
        }
    });
}

// init maps
function initMap() {
    const maps = document.querySelectorAll('.map');
    for (const map of maps) {
        let isclick = false;

        map.addEventListener('mousedown', () => {
            isclick = true;
            map.classList.remove('tab');
        })
        map.addEventListener('mouseup', () => {
            isclick = false;
            map.classList.remove('tab');
        })
        map.addEventListener('focus', () => {
            if (!isclick) {
                map.classList.add('tab');
            }
        })
        map.addEventListener('blur', () => {
            isclick = false;
            map.classList.remove('tab');
        })

        const lat = Number(map.getAttribute('data-lat'));
        const long = Number(map.getAttribute('data-lng'));

        var leaflet = window.L.map(map).setView([lat, long], 13);

        window.L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png').addTo(leaflet);

        leaflet.on('popupopen', function (e) {
            const closebutton = document.querySelector('.leaflet-popup-close-button');
            closebutton.setAttribute('aria-label', 'Fermer');
        });

        var LeafIcon = window.L.Icon.extend({
            iconSize: [25, 41],
            iconAnchor: [12.5, 41],
        });

        var icon = new LeafIcon({
            iconUrl: '/wp-content/themes/biep/assets/img/marker-icon-2x.png',
            iconSize: [25, 41],
            iconAnchor: [12.5, 41],
        })

        window.L.marker([lat, long], {
            alt: map.dataset.pointerTitle + " " + map.dataset.pointerLocation_name,
            icon: icon
        }).addTo(leaflet).bindPopup(map.dataset.pointerTitle + " " + map.dataset.pointerLocation_name);


        var ukrainianFlag = '<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="12" height="8" viewBox="0 0 12 8" class="leaflet-attribution-flag"><path fill="#4C7BE1" d="M0 0h12v4H0z"/><path fill="#FFD500" d="M0 4h12v3H0z"/><path fill="#E0BC00" d="M0 7h12v1H0z"/></svg>';
        leaflet.attributionControl.setPrefix('<a href="https://leafletjs.com" title="Leaflet, librairie javascript pour les cartes">' + (window.L.Browser.inlineSvg ? ukrainianFlag + ' ' : '') + 'Leaflet</a> | ©️️ les contributeurs d’<a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>');

        leaflet.zoomControl.remove();
        window.L.control.zoom(
            {
                zoomInTitle: 'Faire un zoom avant',
                zoomOutTitle: 'Faire un zoom arrière'
            }
        ).addTo(leaflet);
    }
}

window.onload = function () {
    initMap();

    const btnAccountMobile = document.querySelector('#account-list-btn-mobile');
    if (btnAccountMobile) btnAccountMobile.setAttribute('aria-controls', 'account-list-nav-mobile');
};


// move modals outside main
window.initDialogs = false;
const dialogs = document.querySelectorAll('dialog');
for (const dialog of dialogs) {
    const html = dialog.outerHTML;
    const twice = dialog;
    const btns = document.querySelectorAll('[aria-controls="' + dialog.id + '"]:not(.fr-link--close)');

    dialog.remove();

    if (body.classList.contains('page-template-template-page-archive-offer')) {
        body.querySelector('form').appendChild(twice);
    } else {
        body.appendChild(twice);
    }

    const closers = twice.querySelectorAll('.close-modal');


    for (const closer of closers) {
        closer.addEventListener('click', function (e) {
            const realCloser = closer.closest('dialog').querySelector('.fr-link--close');
            realCloser.dispatchEvent(new Event('click'));
        });
    }

    var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
            if (mutation.type == "attributes" && mutation.attributeName == "class") {

                let isOpen = twice.classList.contains('fr-modal--opened');

                setTimeout(function (e) {
                    if (isOpen) {
                        if (!window.initDialogs) {
                            window.initDialogs = true;
                        }

                        header.setAttribute('aria-hidden', true);
                        main.setAttribute('aria-hidden', true);
                        footer.setAttribute('aria-hidden', true);
                        aside.setAttribute('aria-hidden', true);
                        twice.setAttribute('aria-modal', true);

                        const close = twice.querySelector('.fr-link--close');

                        setTimeout(function () {
                            close.focus();
                        }, 45);

                    } else {
                        header.removeAttribute('aria-hidden');
                        main.removeAttribute('aria-hidden');
                        footer.removeAttribute('aria-hidden');
                        aside.removeAttribute('aria-hidden');
                        twice.setAttribute('aria-modal', false);

                        for (const btn of btns) {
                            btn.setAttribute('data-fr-opened', false);
                        }

                        if (window.initDialogs) {

                            if (!window.lastFocus || window.lastFocus == undefined) {
                                window.lastFocus = document.querySelector('#' + twice.getAttribute('data-last-focus')) || false;
                            }

                            if (window.lastFocus && document.querySelectorAll('.strate-banner.show').length == 0) {
                                window.lastFocus.focus();
                                window.lastFocus = false;

                            }
                        }
                    }
                }, 150);
            }
        });
    });

    observer.observe(twice, {
        attributes: true
    });
}

// modal openers
const openers = document.querySelectorAll('[data-open]');
for (const opener of openers) {
    opener.addEventListener('click', () => {
        Cookies.create('redirect_url', window.location.href, 1);
        const id = opener.getAttribute('data-open');
        //console.log(opener.id);
        if (opener.id === "btn-postuler") {
            document.querySelector('dialog#modal-login').setAttribute('data-from', 'postuler');
        }
        Utils.openDsfrModal(id);
    });
}


const btn_connect = document.getElementById('account-btn');

if (btn_connect) {
    btn_connect.addEventListener('click', () => {
        // btn_connect.setAttribute('aria-expanded', true);
        const modale = document.getElementById(btn_connect.getAttribute('aria-controls'));
        modale.querySelector('.fr-link--close').addEventListener('click', () => {
            // btn_connect.setAttribute('aria-expanded', false);
        }, { once: true })

    });
}

// pacours
const focusers = document.querySelectorAll('[data-parcours-focuser]');

for (const focuser of focusers) {

    focuser.addEventListener('click', () => {

        Cookies.create('redirect_url', window.location.href, 1);
        const type = focuser.getAttribute('data-parcours-focuser');
        const steps = document.querySelectorAll('[data-parcours="' + type + '"]');

        for (const step of steps) {
            step.setAttribute('data-last-focus', focuser.id);
        }
    });
}

// resize fiexed els
function resizeEls() {
    const resizeToWrapperEls = document.querySelectorAll('.multiple.fr-select');
    for (const el of resizeToWrapperEls) {

        const ref = el.closest('.fr-input-group');

        if (ref) {
            const w = ref.getBoundingClientRect().width;

            el.style.width = w + 'px';
        }
    }
}

resizeEls();

window.addEventListener('resize', () => {

    resizeEls();

    clearTimeout(window.resizedFinished);
    window.resizedFinished = setTimeout(function () {
        resizeEls();
    }, 150);

});


// videos API
const firstScriptTag = document.getElementsByTagName('script')[0];

// youtube api
let yttag = document.createElement("script");
yttag.defer = true;
yttag.src = 'https://www.youtube.com/iframe_api';
yttag.id = 'yt_api'
firstScriptTag.parentNode.insertBefore(yttag, firstScriptTag);

// daylimotion
let dmtag = document.createElement("script");

dmtag.defer = true;
dmtag.src = 'https://api.dmcdn.net/all.js';
dmtag.id = 'dm_api'
firstScriptTag.parentNode.insertBefore(dmtag, firstScriptTag);

// videos
const mediaWrappers = document.querySelectorAll('.media-wrapper[data-modal-id]');

const videosYt = {};
const videosDm = {};

var i = 0;
for (const mediaWrapper of mediaWrappers) {
    const isVideo = mediaWrapper.hasAttribute('data-video-id');
    const modalId = mediaWrapper.getAttribute('data-modal-id');
    const modal = document.querySelector('#' + modalId) || false;
    const modalBody = modal.querySelector('.fr-modal__body');

    const transcriptionBtn = mediaWrapper.querySelector('.transcription button') || false;
    const transcriptionAccordion = modal.querySelector('.accordion__btn') || false;
    const accordion = modal.querySelector('.accordion') || false;

    if (transcriptionAccordion) {
        transcriptionBtn.addEventListener('click', function (e) {
            window.lastFocus = transcriptionBtn;
            accordion.querySelector('button').setAttribute('aria-expanded', true);
            accordion.querySelector('.collapse').classList.add('active');
            setTimeout(function () {
                modalBody.scrollTop = accordion.offsetTop;
            }, 50);
        })
    }

    if (isVideo) {
        const videoWrapper = modal.querySelector('.video-wrapper');
        const videoId = mediaWrapper.getAttribute('data-video-id');
        const videoType = mediaWrapper.getAttribute('data-video-type');

        // var player;
        const container = document.querySelector('#player-' + videoId + '-' + modalId);

        if (videoType == "youtube") {

            videosYt[i] = {
                'id': videoId,
                'modal': modal,
                'container': container
            };

        } else if (videoType == "dailymotion") {

            videosDm[i] = {
                'id': videoId,
                'modal': modal,
                'container': container
            };

        }

        i++;
    }
}

window.onYouTubeIframeAPIReady = () => {
    for (const [i, video] of Object.entries(videosYt)) {
        console.log(video.container.id);

        const title = 'Vidéo YouTube ' + video.container.getAttribute('data-title');

        const player = new YT.Player(video.container, {
            videoId: video.id,
            title: video.container.getAttribute('data-title'),
            playerVars: {
                mute: 1,
                autoplay: 0,
                controls: 1,
                autohide: 1,
                modestbranding: 1,
                showinfo: 0,
                rel: 0,
            },
            events: {
                onReady() {
                    document.getElementById(video.container.id).setAttribute('title', title);
                },
            }

        });

        var observer = new MutationObserver(function (mutations) {
            mutations.forEach(function (mutation) {

                if (mutation.type == "attributes" && mutation.attributeName == "class") {
                    setTimeout(function (e) {
                        let isOpen = video.modal.classList.contains('fr-modal--opened');
                        if (!isOpen) {
                            player.stopVideo();
                        }
                    }, 150);
                }
            });
        });

        observer.observe(video.modal, {
            attributes: true
        });
    }

}

window.dmAsyncInit = () => {
    for (const [i, video] of Object.entries(videosDm)) {
        const title = 'Vidéo Dailymotion ' + video.container.getAttribute('data-title');

        const iframe = document.createElement('iframe');
        iframe.setAttribute('width', '100%');
        iframe.setAttribute('height', '100%');
        iframe.setAttribute('frameborder', '0');
        iframe.setAttribute('allowfullscreen', 'true');
        iframe.setAttribute('title', title);
        iframe.src = `https://www.dailymotion.com/embed/video/${video.id}`;

        video.container.appendChild(iframe);

        var observer = new MutationObserver(function (mutations) {
            mutations.forEach(function (mutation) {
                if (mutation.type == "attributes" && mutation.attributeName == "class") {
                    setTimeout(function (e) {
                        let isOpen = video.modal.classList.contains('fr-modal--opened');
                        if (!isOpen) {
                            iframe.contentWindow.postMessage('{"method":"pause"}', '*');
                        }
                    }, 150);
                }
            });
        });
        observer.observe(video.modal, {
            attributes: true
        });
    }
}


window.addEventListener('keydown', function (e) {
    if (e.keyCode == 27) {
        var activePopin = document.querySelector('.fr-modal--opened');

        if (activePopin) {
            activePopin.classList.remove('fr-modal--opened');
        }
    }
})


/* 
 * piano event without consent
 * Attention l'event si pas consent n'est pas aussi complet que si content!!
 * pa.privacy.currentMode  (exempt, optin) 
*/

function pianoIfExempt() {
    const at_internet_code = document.body.getAttribute('data-at-internet');

    if (typeof pa != 'object') return;

    pa.setConfigurations({
        'site': at_internet_code,
        'collectDomain': "https://logs1412.xiti.com",
    });

    const user_id = document.querySelector('#user_id').value;
    const user_type = document.querySelector('#user_type').value;
    const level_1 = document.querySelector('#level_1').value;
    const level_2 = document.querySelector('#level_2').value;
    const level_3 = document.querySelector('#level_3').value;
    const page_name = document.querySelector('#page_name').value;
    const page_type = document.querySelector('#page_type').value;
    const content_categorie = document.querySelector('#content_categorie').value;
    const content_versant = document.querySelector('#content_versant').value;
    const content_dept = document.querySelector('#content_dept').value;
    const content_reg = document.querySelector('#content_reg').value;
    const content_metier = document.querySelector('#content_metier').value;
    const content_domaine = document.querySelector('#content_domaine').value;
    const content_entite = document.querySelector('#content_entite').value;
    const content_ref = document.querySelector('#content_ref').value;
    const content_startPublicationDate_day = document.querySelector('#content_startPublicationDate_day').value;
    const content_startPublicationDate_month = document.querySelector('#content_startPublicationDate_month').value;
    const content_startPublicationDate_year = document.querySelector('#content_startPublicationDate_year').value;
    const content_modificationDate_day = document.querySelector('#content_modificationDate_day').value;
    const content_modificationDate_month = document.querySelector('#content_modificationDate_month').value;
    const content_modificationDate_year = document.querySelector('#content_modificationDate_year').value;

    pa.privacy.include.event('click.exit');
    pa.privacy.include.properties([
        'content_categorie',
        'content_versant',
        'content_dept',
        'content_entite',
        'content_reg',
        'content_metier',
        'content_domaine',
        'content_ref',
        'content_startPublicationDate_day',
        'content_startPublicationDate_month',
        'content_startPublicationDate_year',
        'content_modificationDate_day',
        'content_modificationDate_month',
        'content_modificationDate_year'
    ]);
    
    pa.setProperties({
        'page': page_name,
        'page_chapter1': level_1,
        'page_chapter2': level_2,
        'page_chapter3': level_3,
        'page_type': page_type,
        'user_id': user_id,
        'user_category': user_type,
        'accessibility': [],
        'content_categorie': content_categorie,
        'content_versant': content_versant,
        'content_dept': content_dept,
        'content_entite': content_entite,
        'content_reg': content_reg,
        'content_metier': content_metier,
        'content_domaine': content_domaine,
        'content_ref': content_ref,
        'content_startPublicationDate_day': content_startPublicationDate_day,
        'content_startPublicationDate_month': content_startPublicationDate_month,
        'content_startPublicationDate_year': content_startPublicationDate_year,
        'content_modificationDate_day': content_modificationDate_day,
        'content_modificationDate_month': content_modificationDate_month,
        'content_modificationDate_year': content_modificationDate_year,
    }, {
        'persistent': true,
    });


    function sendEvent(data) {
        const json = JSON.parse(data);
        pa.sendEvent(json.event, json.data);
    }

    const clickEvents = document.querySelectorAll('[data-at-click-exempt]');
    clickEvents.forEach((el) => {
        el.addEventListener('click', (e) => {
            if (el.tagName == "A" && el.target !== "_blank") {
                e.preventDefault();
            }
            const data = el.getAttribute('data-at-click-exempt');
            sendEvent(data);
            if (el.tagName == "A" && el.target !== "_blank") {
                document.location = el.href;
            }
        });
    });


}

pianoIfExempt();

/*
 * RGPD
 */
Rgpd(cat => {
    console.log('rgpd');
    // if (window.ParamsDataEnv.prod === true || window.ParamsDataEnv.preprod === true) {
    if (cat === 'stats') {
        //Implémentation AT Internet
        Atinternet();
    }
    // }
}, () => {
    // Exempt
});



document.documentElement.className = 'js';

conditioner.addPlugin({
    // the plugin "monitor" hook
    // use in html : <div data-module="modules/component.js" data-context="@visible true"></div>
    monitor: {
        // the name of our monitor, not prefixed with "@"
        name: 'visible',

        // the monitor factory method, this will create our monitor
        create: (context, element) => ({
            // current match state
            matches: false,

            // called by conditioner to start listening for changes
            addListener(change) {
                new IntersectionObserver((entries) => {
                    // update the matches state
                    this.matches = entries.pop().isIntersecting === context;

                    // inform conditioner of the new state
                    change();
                }).observe(element);
            },
        }),
    },

    // converts module aliases to paths
    moduleSetName: (name) => `./modules/${name}.js`,

    // get the module constructor
    moduleGetConstructor: (module) => module.default,

    // override the import (this makes webpack bundle all the dynamically included files as well)
    // https://webpack.js.org/api/module-methods/#import-
    // - set to "eager" to create a single chunk for all modules
    // - set to "lazy" to create a separate chunk for each module
    moduleImport: (name) => import( /* webpackMode: "lazy" */ `${name}`),
});

conditioner.hydrate(document.documentElement);
